import {
  CircularProgress,
  DialogTitle,
  Stack,
  Typography,
  Divider,
} from "@mui/material";
import {
  CloseIconWrapper,
  FontGrayNormal,
  ModalTitle,
  StyledContainedButton,
  StyledDialog,
  StyledOutlinedButton,
} from "./style";
import { CloseIcon } from "../../assets/Icons";
import { DeleteConfirmationModalProps } from "../../utils/propTypes";
import { useTheme } from "styled-components";

const DeleteConfirmationModal = ({
  isOpen,
  handleClose,
  handleDelete,
  modalTitle,
  modalDescription,
  loading = false,
  btnLabel = "Delete",
}: DeleteConfirmationModalProps) => {
  const theme = useTheme();

  const renderDescription = () => {
    if (!modalDescription) return null;

    if (typeof modalDescription === "string") {
      return (
        <FontGrayNormal variant="body2">{modalDescription}</FontGrayNormal>
      );
    }

    // If ReactNode (JSX) is passed, render directly
    return <>{modalDescription}</>;
  };

  return (
    <StyledDialog onClose={handleClose} open={isOpen} maxWidth="sm" fullWidth>
      <Stack spacing={3} sx={{ p: 3 }}>
        {/* Header */}
        <DialogTitle
          sx={{
            p: 0,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Stack spacing={0.5}>
            <ModalTitle>{modalTitle}</ModalTitle>
            {renderDescription()}
          </Stack>
          <CloseIconWrapper aria-label="close" onClick={handleClose}>
            <CloseIcon />
          </CloseIconWrapper>
        </DialogTitle>

        <Divider />

        {/* Action Buttons */}
        <Stack direction="row" justifyContent="flex-end" spacing={1.5}>
          <StyledOutlinedButton
            variant="outlined"
            size="medium"
            onClick={handleClose}
          >
            Cancel
          </StyledOutlinedButton>

          <StyledContainedButton
            variant="contained"
            size="medium"
            background={theme.colors.red200}
            onClick={handleDelete}
            disabled={loading}
            sx={{
              minWidth: 100,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "0.5rem",
            }}
          >
            {loading && (
              <CircularProgress size={18} sx={{ color: theme.colors.black2 }} />
            )}
            {btnLabel}
          </StyledContainedButton>
        </Stack>
      </Stack>
    </StyledDialog>
  );
};

export default DeleteConfirmationModal;
